






import Vue from 'vue'
import VoiceListContainer from '@/containers/Voice/List'
import FetchVoicesUseCase from '@/usecases/voice/FetchVoicesUseCase'

export default Vue.extend({
  components: {
    VoiceListContainer
  },
  middleware: ['loginCheck'],
  data() {
    return {
      breadcrumb: [{ name: 'トップ', link: '/' }, { name: 'お客さまの声' }]
    }
  },
  async fetch({ query, $contentfulGateway, $voiceRepository, $pagerRepository }) {
    const pageQuery = query['page']
    const page = typeof pageQuery === 'string' ? parseInt(pageQuery, 10) : 1

    const fetchVoicesUseCase = new FetchVoicesUseCase({
      contentfulGateway: $contentfulGateway,
      voiceRepository: $voiceRepository,
      pagerRepository: $pagerRepository
    })

    try {
      await fetchVoicesUseCase.execute({ page, perPage: 10 })
    } catch (e) {
      console.log(e)
      // TODO: Handle error
    }
  },
  watchQuery: ['page']
})
